export const FETCHED_LANGUAGES = 'FETCHED_LANGUAGES'
export const FETCHING_LANGUAGES = 'FETCHING_LANGUAGES'
export const SET_LANGUAGE = 'SET_LANGUAGE'


export function languages(
  languages={
    isFetching: true,
    languages: [
      {
        key: 'en',
        text: 'EN',
        title: 'English',
        value: 'en',
      },
      {
        key: 'es',
        text: 'ES',
        title: 'Español',
        value: 'es',
      },
      {
        key: 'mx',
        text: 'MX',
        title: 'México',
        value: 'mx',
      },
      {
        key: 'ca',
        text: 'CA',
        title: 'Català',
        value: 'ca',
      },
      {
        key: 'el',
        text: 'EL',
        title: 'Ελληνικά',
        value: 'el',
      },
      {
        key: 'eu',
        text: 'EU',
        title: 'Euskal',
        value: 'eu',
      },
      {
        key: 'it',
        text: 'IT',
        title: 'Italiano',
        value: 'it',
      },
      {
        key: 'ro',
        text: 'RO',
        title: 'Română',
        value: 'ro',
      },
      {
        key: 'hr',
        text: 'HR',
        title: 'Hrvatski',
        value: 'hr',
      },
      {
        key: 'sv',
        text: 'SV',
        title: 'Svenska',
        value: 'sv',
      },
    ],
  },
  action,
) {
  switch (action.type) {
    case FETCHING_LANGUAGES:
      return {
        ...languages,
        isFetching: true,
        languages: [],
      }
    case FETCHED_LANGUAGES:
      return {
        ...languages,
        isFetching: false,
        languages: action.languages
      }
    default:
      return languages
  }
}
